export const setTokenExpired = tokenExpired => {
	return { type: 'SET_TOKEN_EXPIRED', tokenExpired };
};